import React from 'react';
import { ArrowLeft, Upload } from 'lucide-react';

export function InvoiceHeader({ isEdit, isSales, nextInvoiceNumber, uploading, onBack, onPDFUpload }) {
  return (
    <div className="flex items-center gap-4">
      <button onClick={onBack} className="p-2 hover:bg-slate-100 rounded-md"><ArrowLeft className="w-5 h-5 text-slate-600" /></button>
      <div className="flex-1">
        <h1 className="font-heading font-bold text-2xl tracking-tight text-slate-900 dark:text-slate-100">{isEdit ? 'Edit Invoice' : (isSales ? 'New Tax Invoice (Sales)' : 'New Purchase Voucher')}</h1>
        <p className="text-sm text-slate-500 font-body">{isEdit ? '' : (isSales ? 'Sales tax document with GST' : 'Purchase voucher with Input GST')}
          {!isEdit && nextInvoiceNumber && <span className="ml-2 font-mono text-purple-600 dark:text-purple-400 font-semibold" data-testid="preview-invoice-number">Next: {nextInvoiceNumber}</span>}
        </p>
      </div>
      <label className="btn-secondary flex items-center gap-2 cursor-pointer" data-testid="upload-pdf-btn">
        <Upload className="w-4 h-4" strokeWidth={1.5} />
        {uploading ? 'Extracting...' : 'Upload PDF'}
        <input type="file" accept=".pdf" onChange={onPDFUpload} className="hidden" disabled={uploading} />
      </label>
    </div>
  );
}

export function VoucherTypeSelector({ form, isSales, nextInvoiceNumber, onChange }) {
  return (
    <div className="flex items-center gap-3 bg-white border border-slate-200 rounded-md px-4 py-3 flex-wrap" data-testid="voucher-type-selector">
      <span className="text-sm font-semibold text-slate-700">Voucher Type:</span>
      <button onClick={() => onChange('voucher_type', 'sales')} data-testid="voucher-type-sales"
        className={`px-4 py-1.5 rounded-md text-sm font-medium transition-all ${isSales ? 'bg-emerald-600 text-white shadow-sm' : 'bg-slate-100 text-slate-600 hover:bg-slate-200'}`}>
        Sales Voucher
      </button>
      <button onClick={() => onChange('voucher_type', 'purchase')} data-testid="voucher-type-purchase"
        className={`px-4 py-1.5 rounded-md text-sm font-medium transition-all ${!isSales ? 'bg-amber-600 text-white shadow-sm' : 'bg-slate-100 text-slate-600 hover:bg-slate-200'}`}>
        Purchase Voucher
      </button>
      <div className="ml-auto flex items-center gap-2">
        <label className="text-xs font-semibold text-slate-600 whitespace-nowrap">Invoice #</label>
        <input type="text" value={form.invoice_number || nextInvoiceNumber || ''} readOnly disabled
          placeholder="Auto from Bill Book" className="form-input font-mono text-sm w-64 bg-slate-50 cursor-not-allowed"
          data-testid="invoice-number-input" title="Numbers are auto-assigned from the branch Bill Book and cannot be edited." />
      </div>
    </div>
  );
}
